import React from 'react';
import { TasksGroupFilterContainer } from './TasksGroupFilter';

export const FIX_HIERARCHY_PORTAL_ID = 'fix-hierarchy-portal';

export default function PlanFilterContainer() {
  return (
    <>
      <div id="filter1" />
      <div id="filter2" />
      <div id="details-box-dates" />
      <TasksGroupFilterContainer />
      <div id={FIX_HIERARCHY_PORTAL_ID} />
    </>
  );
}
